"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsightsEndpoints = void 0;
exports.InsightsEndpoints = {
    // Chain api
    "chain/stake": "/chain/stake",
    "chain/transaction": "/chain/transaction",
    "chain/blocktime": "/chain/blocktime",
    "chain/inflation": "/chain/inflation",
    // User api
    "user/active": "/user/active",
    "user/profile": "/user/profile",
    "user/total": "/user/total",
    "user/growth": "/user/growth",
    "user/volume": "/user/:address/volume",
    "user/pnl": "/user/:address/pnl",
    "user/balance/graph": "/user/:address/balance/graph",
    "user/pnl/graph": "/user/:address/pnl/graph",
    "user/connected/wallet": "/user/connected/wallet",
    // Pool api
    "pool/list": "/pool/list",
    "pool/volume": "/pool/:poolId/volume",
    "pools/volume": "/pool/volume",
    "pools/liquidity": "/pool/liquidity",
    "pool/history": "/pool/history",
    "pool/perp/history": "/pool/perp/history",
    "pool/perp/apy": "/pool/perp/:id/apy",
    "user/pool/rewards": "/user/:address/pool/rewards",
    //market
    "market/volume": "/market/volume",
    // Node api
    "node/list": "/node/list",
    // Balance api
    "balance/total": "/balance/total",
    "balance/list": "/balance/list",
    "balance/change": "/balance/:address/change",
    "balance/supply": "/balance/supply",
    "balance/history": "/balance/:address/:denom/history",
    "balance/distribution": "/balance/distribution",
    // Position api
    "position/leaderboard": "/position/:fromUnix/:toUnix/leaderboard",
    "position/view": "/position/view/:view",
    "position/liquidation": "/position/liquidation",
    "position/liquidation/engine": "/position/liquidation/engine",
    "position/stats": "/position/stats/:address",
    // Competition api
    "competition/list": "/competition/list",
    "competition/leaderboard": "/competition/leaderboard",
    "competition/leaderboardpnl": "/competition/leaderboardpnl",
    "competition/leaderboardlottery": "/competition/leaderboardlottery",
    "competition/leaderboardleague": "/competition/leaderboardleague",
    "competition/leaderboardvolume": "/competition/leaderboardvolume",
    //Coin Gecko Tokens api
    "info/denom_gecko_map": "/info/denom_gecko_map",
    //funding
    "market/funding/history/all": "/market/funding/history/all",
    "market/funding/history": "/market/funding/history",
    // Proposal api
    "proposal/votes": "/gov/proposal/:proposalId/votes",
    // Delegations api
    "delegations/delegator": "/delegations/:delegator",
    // Oracles api
    "info/oracles_price": "/info/oracles_price",
    // Alliances api
    "alliances/stake": "/alliances/stake",
    "alliances/rewards": "/alliances/rewards",
    "reward/epoch": "/reward/epoch/:epoch/:unixStart",
    "reward/leaderboard": "/reward/:unixStart/:unixEnd/leaderboard",
};
